angular.module('st').controller('SyncDebuggerController', SyncDebuggerController);
SyncDebuggerController.$inject = ['$scope', '$rootScope', '$sce', '$filter', '$http', '$q', '$timeout', '$interval'];

function SyncDebuggerController($scope, $rootScope, $sce, $filter, $http, $q, $timeout, $interval) {
    var sdm = this;
    sdm.buttonSpinner = false;
    sdm.errorMessage = "";
    sdm.successMessage = "";
    sdm.alertCounter = 0;
    sdm.timerSpeed = 8;
    sdm.timermultiplerspeed = 4;
    sdm.alertVariable = 0;
    sdm.overviewWastTimeChecked = null;
    sdm.overviewLastSync = null;
    sdm.overviewLastSyncStart = null;
    sdm.overviewMissingIdsFromVistaCount = null;
    sdm.nonSyncingCount = null;
    sdm.overviewCinemas = null;
    sdm.currentSyncStatus = null;
    sdm.lastSyncTimeOld = null;
    sdm.cinemaconcessions = null;
    sdm.adminsettings = null;
    sdm.linkedAccountEmail = null;
    sdm.mylinkedaccounts = null;
    sdm.linkedtome = null;
    sdm.btsubscription = null;
    sdm.btsubscriptionid = null;

    // Showtimes & Films tab state
    sdm.films = null;              // film list (null = not loaded yet)
    sdm.filmFilter = "";
    sdm.filmImageStatus = {};      // { [hofilmcode]: { poster: true/false/null, bg: true/false/null } }
    sdm.expandedFilm = null;       // HOFilmCode of the inline-expanded film (accordion)
    sdm.expandedShowtimes = null;  // HOFilmCode whose showtimes sub-accordion is open
    sdm.filmDetail = null;         // detail payload for the expanded showtimes
    sdm.filmShowtimeFilter = "";   // session ID filter inside the showtimes accordion
    sdm.posters = [];              // SF + Vista poster thumbnails for the expanded film
    sdm.posterModal = null;        // currently previewed poster { label, src, full }
    sdm.showtimeModal = null;      // SF-vs-Vista comparison for a single session
    sdm.selectedShowings = {};     // sessionId -> bool
    sdm.showAdvanced = false;      // Advanced diagnostics disclosure

    // Whole-widget initial load gate: show a neutral spinner until the first
    // overview load finishes, then reveal the dashboard. Never reset after.
    sdm.initialLoaded = false;
    sdm.prefetchStarted = false;   // background tab warming runs once
    sdm.refreshing = false;        // overview auto/manual refresh in flight

    // Uptime tab state
    sdm.uptime = null;             // { groups[], recentfailures[] }

    // Admin tab state
    sdm.pings = null;              // [ { name, healthy, responsems, error } ]
    sdm.showServicePoints = false; // service points disclosure

    const timer = ms => new Promise(res => setTimeout(res, ms));

    // Single source of truth for cinemas - cloned on init and on every overview refresh.
    // count = total missing from Vista->SF. persistentCount = still gone after a sync ran (red, real concern).
    // recentCount = just added to Vista, should sync next run (amber, informational). stale = not checked recently (amber).
    var CINEMA_KEY_DEFAULTS = [
        { "id": "001", "name": "", "enabled": false },
        { "id": "002", "name": "GR North", "enabled": true },
        { "id": "003", "name": "Crossroads", "enabled": true },
        { "id": "004", "name": "GR South", "enabled": true },
        { "id": "005", "name": "Rivertown", "enabled": true },
        { "id": "006", "name": "Lansing", "enabled": true },
        { "id": "007", "name": "Benton", "enabled": true },
        { "id": "008", "name": "Mt Pleasant", "enabled": true },
        { "id": "009", "name": "Carousel", "enabled": true },
        { "id": "010", "name": "", "enabled": false },
        { "id": "011", "name": "Getty", "enabled": true },
        { "id": "012", "name": "Meridian Mall", "enabled": false }, // closed 2026-10-05
        { "id": "013", "name": "Studio Park/MT", "enabled": true }
    ].map(function(c) {
        return angular.extend({
            "count": 0,          // missing from Vista->SF (total)
            "persistentCount": 0,// missing AND still gone after a sync ran (real concern -> red)
            "recentCount": 0,    // just added to Vista, should sync next run (informational -> amber)
            "stale": 0,          // not synced or hash-verified recently
            "affected": false,   // has missing showtimes
            "celemonitorstatus": null,  // live mFOSetting from celemonitor
            "cachedopen": false,        // present in mfocinemas cache (= open)
            "futureordering": false     // future ordering on (false = QR-only)
        }, c);
    });

    function freshCinemaKey() {
        return angular.copy(CINEMA_KEY_DEFAULTS);
    }

    sdm.CINEMA_KEY = freshCinemaKey();
    sdm.syncHealth = null; // { updated, verified, stale, total, cinemas[], thresholdminutes }
    sdm.syncProgress = null; // { running, stageindex, stagelabel, stages[], message, updatedat }
    sdm.SYNC_COOLDOWN_MIN = 20; // approx gap between sync runs (sync app cadence)
    sdm.cooldownText = null;    // "last full sync ... · est. next sync ..." when idle

    sdm.showJson = false;
    sdm.showtimeResponse = "awaiting response";
    sdm.tab = 1;
    sdm.lastshowtimes = false;
    sdm.oldshowtimes = null;
    sdm.oldshowtimescount = 0;
    sdm.oldshowtimeCinemas = [];
    sdm.missingshowtimes = null;
    sdm.processingsubscriptions = null;


sdm.isFutureDate = function(date) {
var now = moment();
var date = moment(date);
if (now > date) {
return true;
} else {
return false;
}
console.log('date check');
console.log(date);
}


sdm.getBTSub = function() {
        if (sdm.buttonLocksAndMessage()) {
            return;
        }
        if (!sdm.btsubscriptionid) {
            sdm.errorMessage ="Enter BT Sub ID";
        }
        sdm.btsubscription = null;

        getBTSubscription(sdm.btsubscriptionid)
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    console.log(r);
                    var p = JSON.parse(r);
                    if (p) {
                        console.log(p);
                        sdm.btsubscription = p;
                            
                    } else {
                        sdm.errorMessage = "Failed to get bt subscription";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the vip signups request. Contact support.';
            })
            .finally(function(response) {
                sdm.buttonSpinner = false;
            });
}

    sdm.getVIPClass = function(user) {

        var btCount = 0;
        var vipCount = user.vippoints;

        _.forOwn(user.sub, function(value, key) { 
            if (value) {
                ++btCount;
            }
        });

        if (btCount !== vipCount) {
            return "problem";
        } else {
            return "okay";
        }
    }

    sdm.getVIPSignUpsFn = function() {
        if (sdm.buttonLocksAndMessage()) {
            return;
        }
        sdm.processingsubscriptions = null;

        getVIPSignUps()
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    console.log(r);
                    var p = JSON.parse(r);
                    if (p) {
                        console.log(p);
                        sdm.processingsubscriptions = p;
                            
                    } else {
                        sdm.errorMessage = "Failed to get vip signups";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the vip signups request. Contact support.';
            })
            .finally(function(response) {
                sdm.buttonSpinner = false;
            });
    }

    sdm.setTab = function(newTab) {
        sdm.tab = newTab;
        // Auto-load the films list the first time the Showtimes & Films tab is opened.
        if (newTab === 2 && sdm.films === null) {
            sdm.loadFilms();
        }
        // Auto-load uptime the first time the Uptime tab is opened.
        if (newTab === 8 && sdm.uptime === null) {
            sdm.loadUptime();
        }
        // Auto-load admin settings + pings the first time the Admin tab is opened.
        if (newTab === 6 && sdm.adminsettings === null) {
            sdm.refreshAdmin();
        }
    };

    sdm.isSet = function(tabNum) {
        return sdm.tab === tabNum;
    };

    sdm.esttime = function(time) {
     return moment(time).tz('America/New_York').format('MM/DD/YYY h:mm A');
    }

    sdm.alertTimer = async function() {
        //console.log('start timer');
        for (sdm.alertVariable = 0; sdm.alertVariable <= sdm.timerSpeed * sdm.timermultiplerspeed; sdm.alertVariable++) {
            var multiplier = sdm.alertVariable === 0 ? 0 : (100 / (sdm.timerSpeed * sdm.timermultiplerspeed));
            var percent = 100 - (sdm.alertVariable * multiplier);
            //console.log(sdm.alertVariable, multiplier, percent);
            $scope.$applyAsync(sdm.alertCounter = percent);
            if (percent === 0) {
                $timeout(function() {
                    $scope.$applyAsync(sdm.errorMessage = null);
                    $scope.$applyAsync(sdm.successMessage = null);
                }, 1000 / sdm.timermultiplerspeed);
            }
            await timer(1000 / sdm.timermultiplerspeed);
        }
    }

    $scope.$watch('sdm.errorMessage', function(newValue, oldValue) {
        if (newValue) {
            sdm.alertTimer();
            // $timeout(function() {
            //     $scope.$applyAsync(sdm.errorMessage = null);
            // }, sdm.timerSpeed * 1000);
        }
    }, true);
    $scope.$watch('sdm.successMessage', function(newValue, oldValue) {
        if (newValue) {
            sdm.alertTimer();
            // $timeout(function() {
            //     $scope.$applyAsync(sdm.successMessage = null);
            // }, sdm.timerSpeed * 1000);
        }
    }, true);

    // Reveal the dashboard once the first overview load has data (health + missing count),
    // then quietly warm the heavy tabs in the background.
    $scope.$watch(function() { return sdm.overviewLoaded(); }, function(loaded) {
        if (loaded) {
            sdm.initialLoaded = true;
            sdm.refreshing = false;
            sdm.prefetchHeavyTabs();
        }
    });

    // Fastest first (Admin/pings), then Films, then the slow Uptime - run sequentially
    // and silently so two heavy calls never overlap and the background work never
    // flickers the global spinner or clears an on-screen message. Runs once.
    sdm.prefetchHeavyTabs = function() {
        if (sdm.prefetchStarted) {
            return;
        }
        sdm.prefetchStarted = true;

        var start = sdm.adminsettings === null ? sdm.refreshAdmin(true) : $q.when();
        start
            .then(function() { return sdm.films === null ? sdm.loadFilms(true) : null; })
            .then(function() { return sdm.uptime === null ? sdm.loadUptime(true) : null; })
            .catch(function() {});
    }

    sdm.bytetomb = function(byte) {
        var mb = byte /1000000;
        var mbceil = Math.ceil(mb);
        var mbstring = String(mbceil).replace(/(.)(?=(\d{3})+$)/g,'$1,');
        return mbstring + " MB";
    }

    sdm.getAdminSettings = function(silent) {
        if (!silent && sdm.buttonLocksAndMessage()) {
            return;
        }
        sdm.adminsettings =  null;
        return getAdminSettings()
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    var p = JSON.parse(r);
                    if (p) {
                        sdm.adminsettings = p;
                    } else if (!silent) {
                        sdm.errorMessage = "Failed to get admin settings.";
                    }
                }
            })
            .catch(function(response) {
                if (!silent) {
                    sdm.errorMessage = 'something went wrong with the admin settings request. Contact support.';
                }
            })
            .finally(function(response) {
                if (!silent) {
                    sdm.buttonSpinner = false;
                }
            });
    }

    // Loads admin settings + connectivity pings together (auto on tab open, or Refresh).
    sdm.refreshAdmin = function(silent) {
        return $q.all([sdm.getAdminSettings(silent), sdm.loadPings()]);
    }

    sdm.loadPings = function() {
        sdm.pings = null;
        return getPings()
            .then(function(response) {
                if (response && response.data && response.data.Success) {
                    var p = JSON.parse(response.data.Data);
                    if (p) {
                        sdm.pings = p;
                    }
                }
            })
            .catch(function(response) {
                // silent-friendly: pings are best-effort, don't toast on failure
            });
    }

    getCinemaConcessionStatus = function() {
        getCinemaConcessions()
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    console.log(r);
                    var p = JSON.parse(r);
                    if (p) {
                        sdm.cinemaconcessions = p;
                        _.each(sdm.cinemaconcessions, function(cinema) {
                            let index = _.findIndex(sdm.CINEMA_KEY, function(i) { return i.id === cinema.id })
                            if (index < 0) {
                                return;
                            }
                            sdm.CINEMA_KEY[index].celemonitorstatus = cinema.celemonitorstatus;
                            sdm.CINEMA_KEY[index].cachedopen = cinema.cachedopen;
                            sdm.CINEMA_KEY[index].futureordering = cinema.futureordering;
                        });
                        console.log(p);
                    } else {
                        sdm.errorMessage = "Failed to get cinema concessions.";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the cinema concessions request. Contact support.';
            })
            .finally(function(response) {

            });
    }


    sdm.overViewStats = function() {
        sdm.refreshing = true;
        sdm.clearOverviewStats();

        getCinemaConcessionStatus();

        // Pseudo sync progress (which stage the sync is on)
        getSyncProgress()
            .then(function(response) {
                if (response && response.data && response.data.Success) {
                    var p = JSON.parse(response.data.Data);
                    if (p) { sdm.syncProgress = p; }
                }
            })
            .catch(function(response) {});

        //get missing showtimes, only look at vistas though
        getMissingShowtimes()
            .then(function(response) {
                if (response && response.data) {
                    var successFlag = response.data.Success;
                    var r = response.data.Data;
                    var p = JSON.parse(r);
                    if (p && successFlag) {
                        sdm.overviewMissingIdsFromVistaCount = p.vistaidsnotinsf.length;
                        sdm.overviewMissingRecent = p.vistarecentcount;
                        sdm.overviewMissingPersistent = p.vistapersistentcount;
                        var cinemasObj = _.countBy(_.flatMap(p.vistaidsnotinsf, (id) => id.split('-')[0]));
                        // Persistent (concern) missing ids, broken down per cinema, so each tile can
                        // tell "still gone after a sync ran" (red) from "just added — should sync next run" (amber).
                        var persistentObj = _.countBy(_.flatMap(p.vistapersistentids || [], (id) => id.split('-')[0]));

                        sdm.overviewCinemas = Object.keys(cinemasObj).map(key => ({ count: cinemasObj[key], id: key }));
                        _.each(sdm.overviewCinemas, function(cinema) {
                            let index = _.findIndex(sdm.CINEMA_KEY, function(i) { return i.id === cinema.id })
                            if (index < 0) {
                                return;
                            }
                            var persistent = persistentObj[cinema.id] || 0;
                            sdm.CINEMA_KEY[index].affected = true;
                            sdm.CINEMA_KEY[index].count = cinema.count;
                            sdm.CINEMA_KEY[index].persistentCount = persistent;
                            sdm.CINEMA_KEY[index].recentCount = cinema.count - persistent;
                        });
                    } else {
                        sdm.errorMessage = "Failed to get missing showtime count.";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the missing showtimes request. Contact support.';
            })
            .finally(function(response) {

            });


        getCurrentSyncingAndLastSync()
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    var p = JSON.parse(r);
                    if (p) {
                        var currentlysyncing = p.currentlysyncing;
                        sdm.overviewLastSync = p.lastsynctime;
                        sdm.overviewLastSyncStart = p.lastsyncstart;

                        //if last sync was less than hour ago, then lastSyncTimeOld is false, as it was recent.
                        if (moment(p.lastsynctime).isAfter(moment().subtract(1, 'hours'))) {
                            sdm.lastSyncTimeOld = false;
                        } else {
                            sdm.lastSyncTimeOld = true;
                        }

                        var syncstopped = p.syncstopped;

                        sdm.currentSyncStatus = currentlysyncing;
                        sdm.updateCooldown();
                    } else {
                        sdm.errorMessage = "Failed to get currently syncing status";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'Failed to get currently syncing status.';
            })
            .finally(function(response) {

            });



        // Hash-aware sync health: updated (synced recently), verified (hash matched - healthy),
        // stale (genuinely not being checked).
        getSyncHealth()
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    var p = JSON.parse(r);
                    if (p) {
                        sdm.syncHealth = p;
                        sdm.nonSyncingCount = p.stale;

                        _.each(p.cinemas, function(cinema) {
                            let index = _.findIndex(sdm.CINEMA_KEY, function(i) { return i.id === cinema.cinemaid })
                            if (index < 0) {
                                return;
                            }
                            sdm.CINEMA_KEY[index].stale = cinema.stale;
                        });
                    } else {
                        sdm.errorMessage = "Failed to get sync health.";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'Failed to get sync health';
            })
            .finally(function(response) {});


        sdm.overviewWastTimeChecked = moment().tz('America/New_York').format('MM/DD h:mm A');
    }

    // --- Overview health helpers -------------------------------------------------

    // Width (%) of each segment in the Updated/Verified/Stale bar
    sdm.healthPercent = function(part) {
        if (!sdm.syncHealth || !sdm.syncHealth.total) {
            return 0;
        }
        return Math.round((part / sdm.syncHealth.total) * 1000) / 10;
    }

    sdm.overviewLoaded = function() {
        return sdm.syncHealth !== null && sdm.overviewMissingIdsFromVistaCount !== null;
    }

    // "Needs attention" = a real concern only: showtimes still missing after a sync ran (persistent),
    // or cinemas not being checked (stale). Just-added showtimes are NOT counted here — they're
    // expected to pull in on the next run, so they shouldn't trip the warning banner.
    sdm.attentionCinemaCount = function() {
        return _.filter(sdm.CINEMA_KEY, function(c) {
            return c.enabled && ((c.persistentCount > 0) || (c.stale > 0));
        }).length;
    }

    // Cinemas whose only "missing" items were just added to Vista (should sync next run) and have
    // nothing persistent/stale. Informational (amber), not an alarm.
    sdm.recentCinemaCount = function() {
        return _.filter(sdm.CINEMA_KEY, function(c) {
            return c.enabled && c.persistentCount <= 0 && c.stale <= 0 && c.recentCount > 0;
        }).length;
    }

    // healthy | warning | syncing | loading - drives the headline banner.
    // While a sync is actively running we don't alarm: stale/missing items are
    // expected to clear as the run progresses, so we show a neutral "in progress" state.
    sdm.healthState = function() {
        if (!sdm.overviewLoaded()) {
            return 'loading';
        }
        if (sdm.currentSyncStatus === true && sdm.attentionCinemaCount() > 0) {
            return 'syncing';
        }
        return sdm.attentionCinemaCount() > 0 ? 'warning' : 'healthy';
    }

    sdm.healthHeadlineText = function() {
        if (!sdm.overviewLoaded()) {
            return 'Checking sync health...';
        }
        if (sdm.healthState() === 'syncing') {
            return 'Sync in progress — catching up on showtimes';
        }
        var n = sdm.attentionCinemaCount();
        if (n === 0) {
            return sdm.recentCinemaCount() > 0
                ? 'Everything is healthy — new showtimes syncing in'
                : 'Everything is healthy';
        }
        return n + (n === 1 ? ' cinema needs attention' : ' cinemas need attention');
    }

    // Maps a raw server state (updated/verified/stale) to its display label.
    sdm.stateLabel = function(state) {
        if (state === 'new') { return 'New'; }
        if (state === 'verified') { return 'Good'; }
        if (state === 'updated') { return 'Updated'; }
        if (state === 'stale') { return 'Stale'; }
        return state;
    }

    sdm.cinemaState = function(cinema) {
        if (!sdm.overviewLoaded()) {
            return 'loading';
        }
        if (cinema.persistentCount > 0) {
            return 'missing';        // red — still gone after a sync ran
        }
        if (cinema.stale > 0) {
            return 'stale';          // amber — not being checked
        }
        if (cinema.recentCount > 0) {
            return 'missing-recent'; // amber — just added to Vista, should sync next run
        }
        return 'healthy';
    }

    sdm.formatBytes = function(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }

    sdm.TimeSince = function(t) {
        return moment(t).fromNow()
    }

    // When no sync is running, show last full sync + an estimated countdown to the next run.
    sdm.updateCooldown = function() {
        if (sdm.currentSyncStatus === true || !sdm.overviewLastSync) {
            sdm.cooldownText = null;
            return;
        }
        var last = 'Last full sync ' + moment(sdm.overviewLastSync).tz('America/New_York').format('MM/DD h:mm A') +
                   ' (' + moment(sdm.overviewLastSync).fromNow() + ')';
        var next = moment(sdm.overviewLastSync).add(sdm.SYNC_COOLDOWN_MIN, 'minutes');
        sdm.cooldownText = next.isAfter(moment())
            ? last + ' · est. next sync ' + next.fromNow()
            : last + ' · next sync due any moment';
    }


    sdm.ToTheTop = function(id) {
        $scope.$applyAsync(sdm.showtimeLookupID = id);
        sdm.lookupShowtime();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    re = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/


    sdm.buttonLocksAndMessage = function() {
        if (sdm.buttonSpinner) {
            return true;
        } else {
            $scope.$applyAsync(sdm.alertCounter = 100);
            $scope.$applyAsync(sdm.alertVariable = 0);
            sdm.buttonSpinner = true;
            sdm.errorMessage = "";
            sdm.successMessage = "";
            return false;
        }
    }

    sdm.clearOverviewStats = function() {
        sdm.overviewWastTimeChecked = null;
        sdm.overviewLastSync = null;
        sdm.overviewLastSyncStart = null;
        sdm.overviewMissingIdsFromVistaCount = null;
        sdm.overviewMissingRecent = null;
        sdm.overviewMissingPersistent = null;
        sdm.nonSyncingCount = null;
        sdm.overviewCinemas = null;
        sdm.currentSyncStatus = null;
        sdm.cinemaconcessions = null;
        sdm.lastSyncTimeOld = null;
        sdm.syncHealth = null;
        sdm.syncProgress = null;
        sdm.CINEMA_KEY = freshCinemaKey();
    }

    sdm.showtimeFormatter = function(value) {
        if (re.test(value) && (value.toString().indexOf("T") >= 0)) {
            return moment(value).tz('America/New_York').format('MM/DD h:mm A');
        } else {
            return value;
        }
    }

    sdm.getmissingshowtimes = function() {
        if (sdm.buttonLocksAndMessage()) {
            return;
        }

        sdm.missingshowtimes = null;

        getMissingShowtimes()
            .then(function(response) {
                if (response && response.data) {
                    var successFlag = response.data.Success;
                    var r = response.data.Data;
                    var p = JSON.parse(r);
                    console.log(p);
                    if (p && successFlag) {
                        sdm.successMessage = "Success! (if empty, then no old showtimes)";
                        sdm.missingshowtimes = p;
                    } else {
                        sdm.errorMessage = "Failed to get missing showtimes.";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the missing showtimes request. Contact support.';
            })
            .finally(function(response) {
                sdm.buttonSpinner = false;
            });
    }

    sdm.CinemaFormatter = function(ary) {
        return ary.join(", ");
    }

    sdm.getlastsyncshowtimes = function() {
        if (sdm.buttonLocksAndMessage()) {
            return;
        }

        sdm.oldshowtimes = null;
        sdm.oldshowtimescount = 0;
        sdm.oldshowtimeCinemas = [];

        getLastSyncShowtimes()
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    var p = JSON.parse(r);
                    console.log(p);
                    if (p) {
                        sdm.successMessage = "Success! (if empty, then no old showtimes)";
                        let result = Object.keys(p).map(key => ({
                            id: key,
                            value: p[key]
                        }));
                        sdm.oldshowtimes = result;
                        sdm.oldshowtimescount = Object.keys(sdm.oldshowtimes).length
                        sdm.oldshowtimeCinemas = _.uniq(_.flatMap(sdm.oldshowtimes, ({ id }) => id.split('-')[0]));
                    } else {
                        sdm.errorMessage = "Failed to get last sync showtimes.";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the last sync showtimes request. Contact support.';
            })
            .finally(function(response) {
                sdm.buttonSpinner = false;
            });
    }


    // Confirmation for any manual sync, nudging users not to collide with the auto sync.
    sdm.confirmSync = function(actionText) {
        var msg = actionText + '\n\nThis re-pulls data from Vista. To avoid colliding with the automatic sync, only run it when a sync is NOT currently in progress.';
        if (sdm.currentSyncStatus === true) {
            msg = "Heads up: a sync looks like it's running right now, so this may collide with it.\n\n" + msg;
        }
        return window.confirm(msg);
    }

    sdm.forceSyncShowtime = function() {
        if (!sdm.confirmSync('Force sync this showtime from Vista?')) {
            return;
        }
        if (sdm.buttonLocksAndMessage()) {
            return;
        }


        showtimeSync(sdm.showtimeLookupID)
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    var p = JSON.parse(r);

                    if (p) {
                        sdm.successMessage = "Synced into Sitefinity. You may lookup again.";
                    } else {
                        sdm.errorMessage = "Failed to syn the showtime sync into Sitefinity.";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the showtimesync request. Contact support.';
            })
            .finally(function(response) {
                sdm.buttonSpinner = false;
            });
    }

    // ===== Films & Showings tab =================================================

    sdm.cinemaName = function(cinemaId) {
        var c = _.find(sdm.CINEMA_KEY, function(i) { return i.id === cinemaId; });
        return (c && c.name) ? c.name : ('Cinema ' + cinemaId);
    }

    sdm.timeOnly = function(t) {
        if (!t) {
            return '--';
        }
        return moment(t).tz('America/New_York').format('h:mm A');
    }

    sdm.dateLabel = function(d) {
        if (!d || d === 'no-date') {
            return 'No date';
        }
        return moment(d, 'YYYY-MM-DD').format('ddd, MMM D');
    }

    sdm.loadFilms = function(silent) {
        if (!silent && sdm.buttonLocksAndMessage()) {
            return;
        }
        sdm.films = null;

        return getFilms()
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    var p = JSON.parse(r);
                    if (p) {
                        sdm.films = p;
                        sdm.filmImageStatus = {};
                        sdm.checkFilmImages(p);
                    } else if (!silent) {
                        sdm.errorMessage = "Failed to load films.";
                    }
                }
            })
            .catch(function(response) {
                if (!silent) {
                    sdm.errorMessage = 'something went wrong with the films request. Contact support.';
                }
            })
            .finally(function(response) {
                if (!silent) {
                    sdm.buttonSpinner = false;
                }
            });
    }

    // Accordion: clicking a film row expands it (shows posters only); clicking the open one collapses it.
    // Showtimes are NOT auto-loaded — they require opening the sub-accordion via toggleShowtimes().
    sdm.toggleFilm = function(hofilmcode) {
        if (sdm.expandedFilm === hofilmcode) {
            sdm.expandedFilm = null;
            sdm.expandedShowtimes = null;
            sdm.filmDetail = null;
            sdm.filmShowtimeFilter = "";
            sdm.selectedShowings = {};
            sdm.posters = [];
            return;
        }
        // Collapsing any previously open showtimes sub-accordion when switching films.
        sdm.expandedShowtimes = null;
        sdm.filmDetail = null;
        sdm.filmShowtimeFilter = "";
        sdm.selectedShowings = {};
        sdm.expandedFilm = hofilmcode;
        sdm.posters = sdm.buildPosters(hofilmcode);
    }

    // Sub-accordion for showtimes inside an expanded film. Lazy-loads film detail on first open.
    sdm.toggleShowtimes = function(hofilmcode) {
        if (sdm.expandedShowtimes === hofilmcode) {
            sdm.expandedShowtimes = null;
            sdm.filmDetail = null;
            sdm.filmShowtimeFilter = "";
            sdm.selectedShowings = {};
            return;
        }
        sdm.expandedShowtimes = hofilmcode;
        sdm.filmDetail = null;
        sdm.filmShowtimeFilter = "";
        sdm.selectedShowings = {};
        sdm.loadFilmDetail(hofilmcode);
    }

    // Returns showings in a date group filtered by sdm.filmShowtimeFilter (session ID).
    sdm.filteredShowings = function(dateGroup) {
        if (!sdm.filmShowtimeFilter) { return dateGroup.showings; }
        var q = sdm.filmShowtimeFilter.toLowerCase();
        return dateGroup.showings.filter(function(s) {
            return s.id && s.id.toLowerCase().indexOf(q) >= 0;
        });
    }

    // Returns true when a filter is set but no showings across the whole film match.
    sdm.filteredShowingsEmpty = function() {
        if (!sdm.filmShowtimeFilter || !sdm.filmDetail) { return false; }
        var found = false;
        _.each(sdm.filmDetail.cinemas, function(cinema) {
            _.each(cinema.dates, function(dg) {
                if (sdm.filteredShowings(dg).length) { found = true; }
            });
        });
        return !found;
    }

    // Poster preview modal (click a thumbnail) - shows it larger with Close / View live.
    sdm.openPosterModal = function(poster) {
        sdm.posterModal = poster;
    }
    sdm.closePosterModal = function() {
        sdm.posterModal = null;
    }
    sdm.viewPosterLive = function() {
        if (sdm.posterModal && sdm.posterModal.full) {
            window.open(sdm.posterModal.full, '_blank');
        }
    }
    // Opens the exact thumbnail URL being previewed (the .tmb-poster{size} image).
    sdm.viewPosterThumb = function() {
        if (sdm.posterModal && sdm.posterModal.src) {
            window.open(sdm.posterModal.src, '_blank');
        }
    }

    // Poster check pane: Sitefinity thumbnail sizes + Vista CDN images for the expanded film.
    // Built once on expand (not in an ng-repeat expression) to avoid digest churn.
    // src = the displayed thumbnail; full = the full-size original opened on click.
    sdm.buildPosters = function(code) {
        if (!code) { return []; }
        var sfPoster = 'https://www.celebrationcinema.com/images/default-source/movie-posters/' + code;
        var sfBg = 'https://www.celebrationcinema.com/images/default-source/movie-backgrounds/' + code;
        var vistaPoster = 'https://api.celebrationcinema.com/CDN/media/entity/get/FilmPosterGraphic/' + code + '?&width=1440';
        var vistaBg = 'https://api.celebrationcinema.com/CDN/Image/Entity/FilmBackdrop/' + code + '?&width=1440';

        var list = [];
        ['175', '300', '500', '700'].forEach(function(size) {
            list.push({
                label: 'SF poster ' + size,
                src: sfPoster + '.tmb-poster' + size + '.jpg?Status=Master',
                full: sfPoster + '.jpg?Status=Master'
            });
        });
        list.push({ label: 'SF background 1440', src: sfBg + '.tmb-poster1440.jpg?Status=Master', full: sfBg + '.jpg?Status=Master' });
        list.push({ label: 'Vista poster', src: vistaPoster, full: vistaPoster, vista: true });
        list.push({ label: 'Vista background', src: vistaBg, full: vistaBg, vista: true });
        return list;
    }

    // Probe Sitefinity poster/background URLs for every film in the list.
    // Populates sdm.filmImageStatus[code].poster / .bg: true = found, false = not found, null = loading.
    sdm.checkFilmImages = function(films) {
        if (!films || !films.length) { return; }
        var sfBase = 'https://www.celebrationcinema.com/images/default-source/';
        films.forEach(function(film) {
            var code = film.hofilmcode;
            if (!code) { return; }
            sdm.filmImageStatus[code] = { poster: null, bg: null };

            var p = new Image();
            p.onload  = function() { $scope.$applyAsync(function() { sdm.filmImageStatus[code].poster = true;  }); };
            p.onerror = function() { $scope.$applyAsync(function() { sdm.filmImageStatus[code].poster = false; }); };
            p.src = sfBase + 'movie-posters/' + code + '.tmb-poster300.jpg?Status=Master';

            var b = new Image();
            b.onload  = function() { $scope.$applyAsync(function() { sdm.filmImageStatus[code].bg = true;  }); };
            b.onerror = function() { $scope.$applyAsync(function() { sdm.filmImageStatus[code].bg = false; }); };
            b.src = sfBase + 'movie-backgrounds/' + code + '.tmb-poster1440.jpg?Status=Master';
        });
    }

    // Returns the CSS class for an img-badge pill (verified = green, stale = red, blank = still loading).
    sdm.imgStatusClass = function(code, type) {
        var s = sdm.filmImageStatus[code];
        if (!s) { return ''; }
        var v = s[type];
        if (v === true)  { return 'verified'; }
        if (v === false) { return 'stale'; }
        return '';
    }

    // Returns the FA icon class for the badge.
    sdm.imgStatusIcon = function(code, type) {
        var s = sdm.filmImageStatus[code];
        if (!s || s[type] === null) { return 'fa-sync fa-spin'; }
        return s[type] ? 'fa-check' : 'fa-times';
    }

    // Returns a human-readable tooltip label.
    sdm.imgStatusLabel = function(code, type) {
        var s = sdm.filmImageStatus[code];
        if (!s || s[type] === null) { return 'checking...'; }
        return s[type] ? 'found' : 'not found';
    }

    sdm.loadFilmDetail = function(hofilmcode) {
        sdm.filmDetail = null;

        getFilmDetail(hofilmcode)
            .then(function(response) {
                if (response && response.data) {
                    if (!response.data.Success) {
                        sdm.errorMessage = response.data.Message || 'Failed to load film detail.';
                        return;
                    }
                    var r = response.data.Data;
                    var p = JSON.parse(r);
                    if (p) {
                        sdm.filmDetail = p;
                    } else {
                        sdm.errorMessage = "Failed to load film detail.";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the film detail request. Contact support.';
            })
            .finally(function(response) {});
    }

    sdm.selectedShowingIds = function() {
        return Object.keys(sdm.selectedShowings).filter(function(id) {
            return sdm.selectedShowings[id];
        });
    }

    sdm.selectedShowingCount = function() {
        return sdm.selectedShowingIds().length;
    }

    sdm.allInGroupSelected = function(dateGroup) {
        if (!dateGroup || !dateGroup.showings || !dateGroup.showings.length) {
            return false;
        }
        return dateGroup.showings.every(function(s) {
            return sdm.selectedShowings[s.id];
        });
    }

    sdm.toggleGroup = function(dateGroup) {
        var selectAll = !sdm.allInGroupSelected(dateGroup);
        dateGroup.showings.forEach(function(s) {
            sdm.selectedShowings[s.id] = selectAll;
        });
    }

    sdm.allShowingIds = function() {
        var ids = [];
        if (!sdm.filmDetail) {
            return ids;
        }
        _.each(sdm.filmDetail.cinemas, function(cinema) {
            _.each(cinema.dates, function(dateGroup) {
                _.each(dateGroup.showings, function(s) {
                    ids.push(s.id);
                });
            });
        });
        return ids;
    }

    sdm.forceSyncSelected = function() {
        var ids = sdm.selectedShowingIds();
        if (!ids.length) {
            sdm.errorMessage = 'No showings selected.';
            return;
        }
        if (!sdm.confirmSync('Force sync ' + ids.length + ' selected showing(s) from Vista?')) {
            return;
        }
        sdm.runBatchSync(ids);
    }

    sdm.forceSyncAllShowings = function() {
        var ids = sdm.allShowingIds();
        if (!ids.length) {
            sdm.errorMessage = 'No showings to sync.';
            return;
        }
        if (!sdm.confirmSync('Force sync ALL ' + ids.length + ' showings for this film from Vista?')) {
            return;
        }
        sdm.runBatchSync(ids);
    }

    sdm.runBatchSync = function(ids) {
        if (sdm.buttonLocksAndMessage()) {
            return;
        }

        var capped = ids.length > 50;
        var batch = ids.slice(0, 50);

        postShowtimeSyncBatch(batch.join(','), sdm.expandedFilm)
            .then(function(response) {
                if (response && response.data) {
                    if (!response.data.Success) {
                        sdm.errorMessage = response.data.Message || 'Batch sync failed.';
                        return;
                    }
                    var p = JSON.parse(response.data.Data);
                    if (p) {
                        sdm.successMessage = 'Synced ' + p.succeeded + ' of ' + p.requested + ' showings' +
                            (p.failed ? ' (' + p.failed + ' failed)' : '') +
                            (capped ? '. Note: only the first 50 were sent.' : '.');
                        sdm.loadFilmDetail(sdm.expandedFilm);
                    } else {
                        sdm.errorMessage = 'Batch sync failed.';
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the batch sync request. Contact support.';
            })
            .finally(function(response) {
                sdm.buttonSpinner = false;
            });
    }

    // Refreshes the film's metadata from Vista (no session re-pull). The batch endpoint
    // treats an empty id list + a film code as a film-metadata-only sync.
    sdm.syncFilm = function() {
        if (!sdm.expandedFilm) {
            return;
        }
        if (!sdm.confirmSync('Sync this film\'s metadata from Vista?')) {
            return;
        }
        if (sdm.buttonLocksAndMessage()) {
            return;
        }

        postShowtimeSyncBatch('', sdm.expandedFilm)
            .then(function(response) {
                if (response && response.data) {
                    if (!response.data.Success) {
                        sdm.errorMessage = response.data.Message || 'Film sync failed.';
                        return;
                    }
                    sdm.successMessage = 'Film metadata synced from Vista.';
                    sdm.loadFilmDetail(sdm.expandedFilm);
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the film sync request. Contact support.';
            })
            .finally(function(response) {
                sdm.buttonSpinner = false;
            });
    }

    sdm.generateSjo = function(type, id) {
        if (sdm.buttonLocksAndMessage()) {
            return;
        }

        postGenerateSjo(type, id)
            .then(function(response) {
                if (response && response.data) {
                    if (!response.data.Success) {
                        sdm.errorMessage = response.data.Message || 'SJO generation failed.';
                        return;
                    }
                    var p = JSON.parse(response.data.Data);
                    if (p && p.success) {
                        sdm.successMessage = 'Generated ' + type + ' SJO.';
                    } else {
                        sdm.errorMessage = 'SJO generation failed.';
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the SJO request. Contact support.';
            })
            .finally(function(response) {
                sdm.buttonSpinner = false;
            });
    }

    // Pre-fill the Showtime Lookup with sessionId, auto-submit, and scroll to it (sits at the top).
    sdm.crossLookupShowtime = function(sessionId) {
        $scope.$applyAsync(sdm.showtimeLookupID = sessionId);
        sdm.lookupShowtime();
        var el = document.getElementById('sdShowtimeLookup');
        if (el && el.scrollIntoView) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    // ===== End Films & Showings tab =============================================

    // ===== Uptime tab ===========================================================

    sdm.uptimeStatusLabel = function(status) {
        if (status === 'good') { return 'Healthy'; }
        if (status === 'warning') { return 'Warning'; }
        if (status === 'slow') { return 'Slow'; }
        if (status === 'critical') { return 'Critical'; }
        return 'No data';
    }

    // Recent-failure hours are stored UTC; convert to Eastern for display.
    sdm.uptimeTime = function(utcValue) {
        if (!utcValue) { return ''; }
        return moment.utc(utcValue).tz('America/New_York').format('MM/DD h:mm A');
    }

    // Daily "last failure" is an Eastern date bucket - show the date only (no clock time).
    sdm.uptimeDate = function(dateValue) {
        if (!dateValue) { return ''; }
        return moment(dateValue).format('MMM D');
    }

    sdm.loadUptime = function(silent) {
        if (!silent && sdm.buttonLocksAndMessage()) {
            return;
        }
        sdm.uptime = null;

        return getUptime()
            .then(function(response) {
                if (response && response.data) {
                    if (!response.data.Success) {
                        if (!silent) { sdm.errorMessage = response.data.Message || 'Failed to load uptime.'; }
                        return;
                    }
                    var p = JSON.parse(response.data.Data);
                    if (p) {
                        sdm.uptime = p;
                    } else if (!silent) {
                        sdm.errorMessage = "Failed to load uptime.";
                    }
                }
            })
            .catch(function(response) {
                if (!silent) {
                    sdm.errorMessage = 'something went wrong with the uptime request. Contact support.';
                }
            })
            .finally(function(response) {
                if (!silent) {
                    sdm.buttonSpinner = false;
                }
            });
    }

    // ===== End Uptime tab =======================================================

    sdm.init = function() {
        sdm.overViewStats();
        // Safety: never leave the loading spinner up indefinitely if a call fails.
        $timeout(function() { sdm.initialLoaded = true; }, 10000);
    }

    sdm.lookupLinkedAccounts = function() {
        if (sdm.buttonLocksAndMessage()) {
            return;
        }

        sdm.linkedtome = null;
        sdm.mylinkedaccounts = null;

        if (!sdm.linkedAccountEmail) {
            sdm.errorMessage = 'no email entered';
            sdm.buttonSpinner = false;
            return;
        }


        getLinkedAccounts(sdm.linkedAccountEmail)
            .then(function(response) {
                if (response && response.data) {
                    if (!response.data.Success) {
                        
                        sdm.errorMessage = response.data.Message || 'something went wrong with the VIP lookup request. Contact support.';   
                        sdm.buttonSpinner = false;    
                        return;                 
                    }

                    var r = response.data.Data;
                    var p = JSON.parse(r);  

                    sdm.mylinkedaccounts = p.mylinkedaccounts;

                    if (p.linkedtome) {
                        sdm.linkedtome = _.remove(p.linkedtome, function(n) {
                            return n.Email.toLowerCase() !== sdm.linkedAccountEmail.toLowerCase();
                        });
                    } else {
                        sdm.linkedtome = p.linkedtome;
                    }

                    sdm.successMessage = 'found links!';
                        $(function () {
                              $('[data-toggle="tooltip"]').tooltip()
                        });
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the VIP lookup request. Contact support.';
            })
            .finally(function(response) {
                sdm.buttonSpinner = false;
            });
    }

    // Open the shared SF-vs-Vista comparison modal for a session id.
    // Used by both the top Showtime Lookup and the per-showing "View" button.
    sdm.openShowtimeModal = function(id) {
        if (!id) {
            sdm.errorMessage = 'no id entered';
            return;
        }
        sdm.showtimeModal = { id: id, loading: true };

        showtimeLookup(id)
            .then(function(response) {
                if (response && response.data) {
                    var p = JSON.parse(response.data.Data);
                    var sf = {};
                    var vista = {};
                    try { sf = JSON.parse(p.sitefinityjson) || {}; } catch (e) { sf = {}; }
                    try { vista = JSON.parse(p.vistajson) || {}; } catch (e) { vista = {}; }

                    if (p.filmname) { sf['Event/Film'] = p.filmname; }
                    if (p.sfDateCreated) { sf['Date Created'] = p.sfDateCreated; }
                    if (p.sfLastModified) { sf['Last Synced'] = p.sfLastModified; }

                    sdm.sitefinityResponse = sf;
                    sdm.vistaResponse = vista;

                    sdm.showtimeModal = {
                        id: id,
                        loading: false,
                        filmname: p.filmname,
                        sf: sf,
                        vista: vista,
                        sfMissing: !!(sf && (sf.empty || sf.error)),
                        vistaMissing: !!(vista && (vista.empty || vista.error)),
                        aligned: sdm.buildShowtimeComparison(sf, vista)
                    };
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the showtime lookup request. Contact support.';
                sdm.showtimeModal = null;
            });
    };

    // Top-bar "Lookup" button.
    sdm.lookupShowtime = function() {
        sdm.openShowtimeModal(sdm.showtimeLookupID);
    };

    sdm.closeShowtimeModal = function() {
        sdm.showtimeModal = null;
    };

    // Force-sync the session shown in the modal (same collision confirmation).
    sdm.forceSyncFromModal = function() {
        if (!sdm.showtimeModal || !sdm.showtimeModal.id) { return; }
        if (!sdm.confirmSync('Force sync session ' + sdm.showtimeModal.id + ' from Vista?')) { return; }
        showtimeSync(sdm.showtimeModal.id)
            .then(function(response) {
                if (response && response.data) {
                    var ok = JSON.parse(response.data.Data);
                    if (ok) {
                        sdm.successMessage = 'Synced ' + sdm.showtimeModal.id + ' into Sitefinity. Re-open to see updated values.';
                    } else {
                        sdm.errorMessage = 'Failed to sync the showtime into Sitefinity.';
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the showtimesync request. Contact support.';
            });
    };

    // Build aligned SF-vs-Vista rows for the comparison modal.
    sdm.buildShowtimeComparison = function(sf, vista) {
        sf = sf || {}; vista = vista || {};
        function pick(o, keys) {
            for (var i = 0; i < keys.length; i++) {
                var val = o[keys[i]];
                if (val !== undefined && val !== null && val !== '') { return val; }
            }
            return '';
        }
        var rows = [
            { label: 'Showtime', sf: pick(sf, ['Showtime', 'StartTime', 'DateTime']), vista: pick(vista, ['Showtime']), time: true },
            { label: 'Film / Event', sf: pick(sf, ['Event/Film', 'ScheduledFilmId', 'FilmID']), vista: pick(vista, ['ScheduledFilmId']) },
            { label: 'Format code', sf: pick(sf, ['FormatCode']), vista: pick(vista, ['FormatCode']) },
            { label: 'Session attributes', sf: pick(sf, ['SessionAttributesNames']), vista: pick(vista, ['SessionAttributesNames']) },
            { label: 'Seats available', sf: pick(sf, ['SeatsAvailable']), vista: pick(vista, ['SeatsAvailable']) },
            { label: 'Sold out', sf: '', vista: pick(vista, ['SoldoutStatus']) },
            { label: 'Allow ticket sales', sf: '', vista: pick(vista, ['AllowTicketSales']) },
            { label: 'Screen', sf: '', vista: pick(vista, ['ScreenName', 'ScreenNumber']) },
            { label: 'Last synced (SF)', sf: pick(sf, ['Last Synced']), vista: '' }
        ];
        rows.forEach(function(r) {
            r.match = sdm.compareShowtimeValues(r.label, r.sf, r.vista);
        });
        return rows;
    };

    // true/false where SF and Vista should agree (times, attributes, seats); else null (just shown).
    sdm.compareShowtimeValues = function(label, sfVal, vistaVal) {
        if (sfVal === '' || vistaVal === '') { return null; }
        try {
            if (label === 'Showtime') {
                // Compare what the user actually sees (Eastern-formatted), avoiding tz false-mismatches.
                return sdm.showtimeFormatter(sfVal) === sdm.showtimeFormatter(vistaVal);
            }
            if (label === 'Session attributes') {
                var norm = function(x) {
                    var arr = angular.isArray(x) ? x : ('' + x).replace(/[\[\]"']/g, '').split(',');
                    return arr.map(function(s) { return ('' + s).toUpperCase().trim(); }).filter(Boolean).sort().join(',');
                };
                return norm(sfVal) === norm(vistaVal);
            }
            if (label === 'Seats available') {
                return parseInt(sfVal, 10) === parseInt(vistaVal, 10);
            }
        } catch (e) {}
        return null;
    };

    function getCurrentSyncingAndLastSync() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/syncstats", config).then(deferred.resolve);
        return deferred.promise;
    }

    function getAdminSettings() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/adminsettings", config).then(deferred.resolve);
        return deferred.promise;
    }

    function getLinkedAccounts(lookupemail) {
        var config = {
            params: {
                email: lookupemail
            }
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/linkedvipusers", config).then(deferred.resolve);
        return deferred.promise;
    }

    function showtimeLookup(showtimeid) {
        var config = {
            params: {
                id: showtimeid
            }
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/showtimes", config).then(deferred.resolve);
        return deferred.promise;
    }

    function showtimeSync(showtimeid) {
        var config = {
            params: {
                id: showtimeid
            }
        };
        var deferred = $q.defer();

        // POST: this mutates data (re-pulls the session from Vista).
        $http.post("/rpc/debugger/showtimesync", null, config).then(deferred.resolve);
        return deferred.promise;
    }

    function getFilms() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/films", config).then(deferred.resolve);
        return deferred.promise;
    }

    function getFilmDetail(hofilmcode) {
        var config = {
            params: {
                id: hofilmcode
            }
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/film", config).then(deferred.resolve);
        return deferred.promise;
    }

    function postShowtimeSyncBatch(ids, filmcode) {
        var config = {
            params: {
                ids: ids,
                filmcode: filmcode
            }
        };
        var deferred = $q.defer();

        $http.post("/rpc/debugger/showtimesyncbatch", null, config).then(deferred.resolve);
        return deferred.promise;
    }

    function postGenerateSjo(type, id) {
        var config = {
            params: {
                type: type,
                id: id
            }
        };
        var deferred = $q.defer();

        $http.post("/rpc/debugger/generatesjo", null, config).then(deferred.resolve);
        return deferred.promise;
    }

    function getUptime() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/uptime", config).then(deferred.resolve);
        return deferred.promise;
    }

    function getPings() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/pings", config).then(deferred.resolve);
        return deferred.promise;
    }

    function getLastSyncShowtimes() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/showtimesmodified", config).then(deferred.resolve);
        return deferred.promise;
    }

    function getSyncProgress() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/syncprogress", config).then(deferred.resolve);
        return deferred.promise;
    }

    function getSyncHealth() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/synchealth", config).then(deferred.resolve);
        return deferred.promise;
    }

function getBTSubscription(btid) {
        var config = {
            params: {
                id: btid
            }
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/btsubscription", config).then(deferred.resolve);
        return deferred.promise;
    }

function getVIPSignUps() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/vipsignups", config).then(deferred.resolve);
        return deferred.promise;
    }


    function getMissingShowtimes() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/showtimesmissing", config).then(deferred.resolve);
        return deferred.promise;
    }

    function getCinemaConcessions() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/cinemaconcessions", config).then(deferred.resolve);
        return deferred.promise;
    }


    var seconds = 60;
    var minutes = 5;
    var ms = 1000;
    var total = minutes * ms * seconds;
    $interval(sdm.overViewStats, total);
    // Keep the idle "next sync" countdown roughly current between full refreshes.
    $interval(sdm.updateCooldown, 30000);
}
